import React, { useEffect, useState } from 'react';

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import { hexToRgb } from 'common/styles/colors';

const LineChart = ({ lineChartData }) => {
  ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend, CategoryScale);

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderColor: 'rgba(0, 0, 0, 1)',
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    if (lineChartData && lineChartData.length > 0) {
      const groupedData = {};
      const optionLabels = [];

      lineChartData.forEach(dataSet => {
        const timeLabel = dataSet.name; // e.g., 'Q1 2024'
        optionLabels.push(timeLabel);

        dataSet.data.forEach(item => {
          const { option_name, overall_score, color } = item;

          if (!groupedData[option_name]) {
            groupedData[option_name] = {
              dataPoints: [],
              lineColor: color,
            };
          }

          groupedData[option_name].dataPoints.push({
            x: timeLabel,
            y: parseFloat(overall_score.toFixed(1)),
          });
        });
      });

      const formattedData = Object.keys(groupedData).map(optionName => ({
        label: optionName,
        data: groupedData[optionName].dataPoints,
        borderColor: hexToRgb(groupedData[optionName].lineColor, 0.8),
        backgroundColor: hexToRgb(groupedData[optionName].lineColor, 1.0),
        fill: false,
        tension: 0.3,
        pointBackgroundColor: hexToRgb(groupedData[optionName].lineColor, 1.0),
        pointBorderColor: '#aaa',
        pointHoverBorderColor: '#000',
        pointRadius: 5,
        pointHoverRadius: 8,
      }));

      setChartData({
        labels: optionLabels, // still used for axis ticks
        datasets: formattedData,
      });
    }
  }, [lineChartData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          font: {
            family: 'Poppins',
            size: 12,
          },
        },
      },
      tooltip: {
        bodyFont: {
          family: 'Poppins',
          size: 12,
        },
        titleFont: {
          family: 'Poppins',
          size: 14,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: false,
          text: 'Quarters',
          font: {
            family: 'Poppins',
            size: 14,
          },
        },
        ticks: {
          font: {
            family: 'Poppins',
            size: 12,
          },
        },
      },
      y: {
        min: 0, // Set the minimum value for Y-axis
        max: 10, // Set the maximum value for Y-axis
        title: {
          display: true,
          text: 'Overall Score',
          font: {
            family: 'Poppins',
            size: 11,
          },
        },
        ticks: {
          font: {
            family: 'Poppins',
            size: 12,
          },
        },
      },
    },
  };

  return (
    <div style={{ height: '470px', width: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LineChart;
